import * as React from "react";
import Direction from "@/components/atomics/direction";
import { MenuType, LeaderboardMetric } from "@/types/leader-board";

interface LeaderBoardMenuProps {
  selectedMenu: MenuType;
  onMenuChange: (menu: MenuType) => void;
  metric: LeaderboardMetric;
  onMetricChange: (metric: LeaderboardMetric) => void;
}

export default function LeaderBoardMenu({
  selectedMenu,
  onMenuChange,
  metric,
  onMetricChange,
}: LeaderBoardMenuProps) {
  const menuItems: { id: MenuType; label: string[] }[] = [
    { id: "collections", label: ["COLLECTIONS"] },
    { id: "nft", label: ["NFT"] },
    { id: "users", label: ["USERS"] },
  ];

  const subTabs: Record<MenuType, LeaderboardMetric[]> = {
    users: ["all_stars", "volume", "level"],
    collections: ["all_stars", "volume"],
    nft: [],
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="flex justify-between items-center gap-x-7 text-[18px]">
        {menuItems.map(({ id, label }) => (
          <div
            key={id}
            className={`relative flex flex-col items-center cursor-pointer transition-colors pt-[25px] ${
              selectedMenu === id ? "--blue" : "text-white"
            }`}
            onClick={() => onMenuChange(id)}
          >
            {label.map((text, index) => (
              <span key={index}>{text}</span>
            ))}
            {selectedMenu === id && (
              <div className="absolute top-[6px]">
                <Direction
                  className="w-[11px] h-[19px] rotate-90"
                  color="#0099FE"
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="flex gap-1 mt-4 mb-8 min-h-[32px] text-base]">
        {subTabs[selectedMenu].map(m => (
          <button
            key={m}
            className={`px-3 py-1 min-w-[120px] ${
              metric === m ? "bg-primary-blue" : "bg-primary-gray"
            }`}
            onClick={() => onMetricChange(m)}
          >
            {m.replace("_", " ").toUpperCase()}
          </button>
        ))}
      </div>
    </div>
  );
}
